import React from 'react';
import HeroImage from '../../../assets/images/services/banking-license/hero-image.png'
import PageBanner from '../../../assets/images/services/banking-license/page-banner.png'

import BreadCrumbs from "../../../components/BreadCrumbs/BreadCrumbs";
import HeroRightImage from "../../../components/Constant/HeroRightImage/HeroRightImage";
import BannerPageImg from "../../../components/Constant/Banner Page Img/BannerPageImg";
import PageList from "../../../components/Constant/List/List";
import { GiCheckMark } from "react-icons/gi";
import { GoDotFill } from "react-icons/go";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import CTA from "../../../components/Constant/cta/CTA";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Button from "../../../components/Constant/button/Button";

const BreadCrumbsData = [
    { name: 'Offshore Advisory', link: '/' },
    {
        name: 'Western Sahara Banking License',
        link: '/banking-license',
    },
]

function WesternSaharaBankingLicense () {

    return (
        <main className='main'>
            <section className='banking-license-section section'>
                <BreadCrumbs data={BreadCrumbsData}/>

                <div className='banking-license-container container'>

                    <h1 className='section-title'>
                        Western Sahara Banking License
                    </h1>

                    <div className='grid-container'>
                        <div className='flex-start'>
                            <h3 className='page-subtitle'>
                                Establish Your Own Offshore Bank with CRA (Western Sahara)
                            </h3>
                            <p className='page-paragraph'>
                                The <b>Capital Regulatory Authority (CRA)</b> of <b>Western Sahara</b> offers <b>two categories of offshore banking licenses</b>, designed for <b>investors, financial institutions, and fintech entrepreneurs</b> looking to operate internationally.
                                <b/>
                                With a <b>Western Sahara Banking License</b>, your institution gains the ability to provide <b>global banking services</b> outside of <b>SADR</b>, positioning your brand as a <b>trusted international player</b>.
                            </p>

                            <PageList
                                items={[
                                    {
                                        title: "Class I Banking License",
                                        paragraph: "Allows full offshore banking operations with international clients and institutions.",
                                        icon: GiCheckMark,
                                    },
                                    {
                                        title: "Class II Banking License",
                                        paragraph: "Permits limited banking activities, typically serving non-resident clients or specific groups.",
                                        icon: GiCheckMark,
                                    },
                                    {
                                        title: "Offshore Advisory Compliance Support",
                                        paragraph: "Comprehensive assistance with regulatory filings, due diligence, and ongoing CRA compliance.",
                                        icon: GiCheckMark,
                                    },
                                ]}
                            />
                            <Button
                                text="Request a Banking License Proposal →"
                                link="/consultation"
                                type="primary"
                                size="large"
                            />
                        </div>

                        <HeroRightImage src={HeroImage} />
                    </div>

                    <BannerPageImg src={PageBanner} />
                    <b/><br/>

                    <div className='flex-start'>
                        <h3 className='page-title'>
                            Why Choose Western Sahara for Banking?
                        </h3>


                        <h3 className='page-title'>
                            Banking License Types
                        </h3>
                        <PageList
                            items={[
                                {
                                    title: "Fast Approvals",
                                    paragraph: "Quicker licensing and operational approval timelines compared to traditional banking regulators.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Global Banking Access",
                                    paragraph: "Connect to SWIFT, IBAN, and EMI networks for full international banking capabilities.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Favorable Regulations",
                                    paragraph: "Designed for international financial operators with flexible compliance requirements.",
                                    icon: GoDotFill,

                                },
                                {
                                    title: "Service Flexibility",
                                    paragraph: "Supports commercial, digital, private, or niche banking models.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Cost-Effective Setup",
                                    paragraph: "Significantly lower setup and maintenance costs than EU or Tier-1 jurisdictions.",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Banking License Types</h3>
                        <h4 className='page-subtitle'>Class I – International Banking License</h4>
                        <p>A <b>Class I License</b> grants <b>full authority</b> to provide <b>international banking services</b> to a <b>global clientele</b>.</p>
                        <p className='page-subtitle'>Capital Requirements</p>
                        <PageList
                            items={[
                                {
                                    paragraph: "No Capital Required",
                                    icon: GoDotFill,
                                },
                            ]}
                        />
                        <p className='page-subtitle'>Key Benefits</p>
                        <PageList
                            items={[
                                {
                                    title: "Global Prestige",
                                    paragraph: "High recognition in offshore banking",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Financial Stability",
                                    paragraph: "Robust capital ensures resilience",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "International Reach",
                                    paragraph: "Attract clients across global markets",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Regulatory Compliance",
                                    paragraph: "Meet CRA’s rigorous standards",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Client Trust",
                                    paragraph: "Strong institutional credibility",
                                    icon: GoDotFill,
                                },
                            ]}
                        />
                        <h4 className='page-subtitle'>Class II – International Banking License</h4>
                        <p>A <b>Class II License</b> offers a <b>more tailored banking framework</b>, allowing institutions to provide services to a <b>curated list of clients approved by the CRA</b>.</p>
                        <p className='page-subtitle'>Capital Requirements</p>
                        <PageList
                            items={[
                                {
                                    paragraph: "Flexible — determined periodically by CRA, adjusted to market needs.",
                                    icon: GoDotFill,
                                },
                            ]}
                        />
                        <p className='page-subtitle'>Key Benefits</p>
                        <PageList
                            items={[
                                {
                                    title: "Focused Client Engagement",
                                    paragraph: "Work with approved clients",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Regulatory Flexibility",
                                    paragraph: "Adaptable capital requirements",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Trust & Stability",
                                    paragraph: "Backed by CRA oversight",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Growth Potential",
                                    paragraph: "Expand into international markets confidently",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <hr className='section-divider'/>

                        <h3 className='page-title'>Licensing Process with Offshore Advisory</h3>
                        <PageList
                            items={[
                                {
                                    title: "Consultation & Strategy",
                                    paragraph: "Assess business model & license class",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "company-formation",
                                    paragraph: "Establish entity under CRA jurisdiction",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Compliance Setup",
                                    paragraph: "Draft AML/KYC policies, risk manuals, business plan",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Application Submission",
                                    paragraph: "Prepare & file with CRA",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Approval & Activation",
                                    paragraph: "Receive license and commence operations",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <hr className='section-divider'/>

                        <h3 className='page-title'>Timeline & Costs</h3>
                        <PageList
                            items={[
                                {
                                    title: "Timeline",
                                    paragraph: "2–3 weeks (subject to document readiness & CRA review)",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Costs",
                                    paragraph: "Class I License: starting from USD 18,000\nClass II License: starting from USD 14,000",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Renewals",
                                    paragraph: "Annual fees payable to CRA",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <hr className='section-divider'/>

                        <h3 className='page-title'>Why Offshore Advisory?</h3>
                        <PageList
                            items={[
                                {
                                    title: "Proven Expertise in CRA Banking Licenses",
                                    paragraph: "",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "End-to-End Service",
                                    paragraph: "Company setup, licensing, compliance, banking integration",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Custom Guidance",
                                    paragraph: "Tailored for private banks, fintechs, and digital banks",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Trusted Network",
                                    paragraph: "Access to global banking & PSP partners",
                                    icon: GoDotFill,
                                },
                            ]}
                        />


                    </div>

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>
                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />
                    <CTA
                        title="Ready to start your own offshore bank?"
                        description="<b>Offshore Advisory</b> delivers <b>end-to-end support</b> for <b>Western Sahara Banking Licenses</b> under <b>CRA</b>, ensuring <b>full compliance</b> and <b>fast approvals</b>."
                        buttonText="Request Your Banking License Proposal →"
                        buttonLink="/consultation"
                    />

                </div>
            </section>


        </main>
    );
}

export default WesternSaharaBankingLicense;

const faqData = [
    {
        question: "Can I operate banking services inside Western Sahara?",
        content: [
            { type: "answer", text: "No. These are international offshore licenses — activity must be outside SADR." },
        ],
    },
    {
        question: "What is the difference between Class I and Class II?",
        content: [
            { type: "list", items: [
                    "Class I: Full banking license, higher capital, broader client base.",
                    "Class II: Restricted license, lower/flexible capital, CRA-approved client list."
                ]},
        ],
    },
    {
        question: "Can a license cover digital banking?",
        content: [
            { type: "answer", text: "Yes — both classes can include digital and online banking services." },
        ],
    },
    {
        question: "How long does it take to obtain a license?",
        content: [
            { type: "answer", text: "Typically 2–3 Weeks, depending on application quality and CRA review speed." },
        ],
    },
    {
        question: "Do you provide compliance support?",
        content: [
            { type: "answer", text: "Yes — we prepare AML/KYC manuals, risk frameworks, and can provide nominee compliance officers." },
        ],
    },
];


const testimonialsData = [
    {
        quote:
            "Offshore Advisory helped us secure a Class I Banking License in Western Sahara. Their step-by-step compliance guidance made the process smooth.",
        author: "Daniel R.",
        role: "Banking Investor",
    },
    {
        quote:
            "We opted for a Class II license to launch a niche digital bank. Offshore Advisory handled everything from licensing to compliance.",
        author: "Sofia M.",
        role: "FinTech Entrepreneur",
    },
];